import { SVGProps } from ".";

export function PointIcon({ color = "black", size = 18 }: SVGProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        color={`${color}`}
        height={`${size}`}
        width={`${size}`}
        stroke={`${color}`}
        strokeWidth="0"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          d="M12.705 20.2991C12.315 20.6869 11.685 20.6869 11.295 20.2991L6.6967 15.728C3.76777 12.8162 3.76777 8.09546 6.6967 5.18377C9.62563 2.27208 14.3743 2.27208 17.3033 5.18377C20.2322 8.09546 20.2322 12.8162 17.3033 15.728L12.705 20.2991ZM16.1247 14.5563C18.4028 12.2917 18.4028 8.61999 16.1247 6.35534C13.8467 4.09069 10.1533 4.09069 7.8752 6.35534C5.59715 8.61999 5.59715 12.2917 7.8752 14.5563L12 18.6569L16.1247 14.5563ZM12 12.1127C11.0795 12.1127 10.3333 11.3709 10.3333 10.4559C10.3333 9.5408 11.0795 8.799 12 8.799C12.9205 8.799 13.6667 9.5408 13.6667 10.4559C13.6667 11.3709 12.9205 12.1127 12 12.1127Z"
          fill={`${color}`}
        />
      </svg>
    </div>
  );
}
